import {Box} from "@mantine/core";
import {useAppSelector} from "../../app/hooks";
import {
    KAIResponseType,
    LowScoreMessage,
    MessageWithMetadata,
    NoAnswerMessage,
    NoSourcesMessage,
} from "../../types";
import {CommonNotification} from "./components/regeneration-notifications/CommonNotification";
import {RootState} from "../../app/store";
import {useMemo} from "react";

interface SuggestKaiPlusProps {
    message: MessageWithMetadata;
    onRegenerate: (responseType?: KAIResponseType) => void;
}

export const SuggestKaiPlus = ({
    onRegenerate,
    message,
}: SuggestKaiPlusProps) => {
    const noSourcesMessage: NoSourcesMessage | undefined = useAppSelector(
        (s: RootState) => s.transientChat.noSourcesMessage
    );
    const lowScoreMessage: LowScoreMessage | undefined = useAppSelector(
        (s: RootState) => s.transientChat.lowScoreMessage
    );
    const noAnswerMessage: NoAnswerMessage | undefined = useAppSelector(
        (s: RootState) => s.transientChat.noAnswerMessage
    );

    const messageToShow:
        | NoSourcesMessage
        | LowScoreMessage
        | NoAnswerMessage
        | undefined = useMemo(() => {
        const anyMsg = noSourcesMessage ?? lowScoreMessage ?? noAnswerMessage;
        if (anyMsg?.messageId !== message.position) {
            return undefined;
        }

        return anyMsg;
    }, [message, noSourcesMessage, lowScoreMessage, noAnswerMessage]);

    return (
        <Box>
            <CommonNotification
                message={messageToShow}
                onRegenerate={onRegenerate}
            />
        </Box>
    );
};
